module.exports = __webpack_public_path__ + "img/16-9.a01d9de6.jpg";